import React, { useEffect } from 'react';
import { Router, Switch, Route, Redirect } from 'react-router-dom';

const RegisterRoute = ({
  component: Component,
  render,
  path,
  authenticated,
  ...rest
}) => {
  return (
    <Route
      path={path}
      {...rest}
      render={(props) =>
        authenticated ? (
          <Redirect to={{ pathname: '/' }} />
        ) : (
          <Component {...props} />
        )
      }
      // render={(props) => {
      //   if (authenticated) {
      //     //   console.log('r', 1, path, authenticated);
      //     return <Redirect to={{ pathname: '/' }} />;
      //   } else {
      //     //   console.log('r', 2, path, authenticated);
      //     return <Component {...props} />;
      //   }
      //   // authenticated ? ( <Redirect to={{ pathname: '/' }} /> ) : ( <Component {...props} /> );
      // }}
    />
  );
};

export default RegisterRoute;
